
import CrmActivityListingMapping from 'vcomponents/listing/apiListing/mapping/CrmActivityListingMapping.js';

export default [
    {
        id: "crm-activity",
        label: window.i18n.__("Activités"),
        buttons: [],
        enableExport: true,
        enableKpisOnExport: false,
        enableFiltering: true,
        enableOptions: true,
        enableContext: true,
        endpoint: '',
        exportOptions: {},
        favorite: null,
        filter: {},
        filtersComponent: undefined,
        linkedtype: "activity",
        name: "crm-activity",
        params: {},
        prefilter: {},
        savedSearchesUrl: "/savedsearch/clients",
        switchDisplay: [],
        url: "/activities/crm/search",
        exportUrl: "/activities/crm/export",
        metaUrl: "/activities/crm/metas",
        useFavorites: false,
        group: 'crm',
        favoritesName: 'crm-activity',
        listingMapping: CrmActivityListingMapping,
        aggregations: ['by_event'],
    },
]